// extracted by mini-css-extract-plugin
module.exports = {"container":"IconButtonWithSVG_container__zE29W","image":"IconButtonWithSVG_image__d8FpD"};